export type TrialProBadgeColors = "blue" | "green" | "grey";

export const colorClasses: {
  [k in TrialProBadgeColors]: string;
} = {
  blue: "cw-text-info cw-bg-info",
  green: "cw-text-positive cw-bg-positive-inset",
  grey: "cw-text-neutral cw-bg-positive-inset-disabled",
};
